// src/NewsTitleAndDate.js
import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import styled from 'styled-components';
import Navbar from '../components/Navbar';
import GlobalStyle from '../GlobalStyles';
import Footer from '../components/Footer';
import parse from 'html-react-parser'


const NewsTitleAndDateContainer = styled.div`
  max-width: 100%;
  margin:0px;
  padding: 0px;
  background-color:#000000;
`;

const NewsContainer = styled.div`
  background-color: #1F1F1F;
  padding: 5% 20% 2.5% 20% ;

  @media (max-width: 500px) {
    padding: 20% 10% 10% 10% ;
  }

`;


const BackLink = styled.a`
  display: flex;
  background-color: transparent;
  align-items: center;
  color: #FFFFFF;
  text-decoration: none;
  font-family: 'Noto Sans TC';
  font-size: 16px;
  line-height: 24px;
  width:100%;2
  margin-bottom: 20px;
  padding: 0% 0% 2.5% 0% ;

  @media (max-width: 500px) {
    display:none;
  }

`;

const ImageContainer = styled.div`
  img {
    max-width: 100%;
    height: auto;
    display: block;
    margin: 0 auto;
    margin-bottom: 10px;
    margin-top: 10px;
  }
`;



const NewsContent = styled.div`
  
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 32px;
  



  color: #EFEFEF;



  @media (max-width: 500px) {
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    padding:0% 0% 10% 0%;
  }
`;

const NewsTitle = styled.h1`
  color: #FFFFFF;
  margin-bottom: 10px;
  font-weight: 700;
  font-size: 36px;
  line-height: 52px;
  letter-spacing: 0.05em;

  @media (max-width: 500px) {
    font-size: 24px;
    line-height: 35px;
  }
  
`;

const NewsDate = styled.p`
  color: #FFFFFF;
  font-size: 16px;
  line-height: 24px;
  padding: 0% 0% 2.5% 0%;
  margin:0 auto;

  @media (max-width: 500px) {
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
  }
`;



const ReadMoreButton = styled.button`
  background-color: transparent;
  color: #FFFFFF;
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 26px;
  letter-spacing: 0.05em;
  display: none;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 12px 40px;
  box-sizing: border-box;
  border: 1px solid rgba(255, 255, 255, 0.6);
  border-radius: 100px;
  cursor: pointer;
  margin: 0 auto;
  margin-top: 48px;

  @media (max-width: 500px) {
    display: block;
    font-size: 14px;
    line-height: 24px;
    margin-top: 24px;
    padding: 6px 20px;
    margin: 0 auto;
  }



  &:hover {
    background-color: #FFFFFF;
    color: #1f1f1f;
  }
`;


function NewsTitleAndDate() {

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const news_id = urlParams.get('id')
  
  const [news, setNews] = useState([])

  const fetchNewsData = () => {
    fetch(`${process.env.REACT_APP_ADMIN_URL}/api/find-news?id=${news_id}`)
      .then(response => {
        return response.json()
      })
      .then(data => {
        setNews(data)
      })
  }

  useEffect(() => {
    fetchNewsData()
  }, [])


  const contentString = `${news.content}`;


  return (

    <NewsTitleAndDateContainer>
   
        <Navbar />
        
        <NewsContainer>
         
          <BackLink href="/info">&#8592;&nbsp;&nbsp;返回相關資訊</BackLink>
          
          <NewsTitle>{news.title}</NewsTitle>
          <NewsDate>{news.news_date}</NewsDate>
          <NewsContent>
            {/* 文章內容 */}
            <ImageContainer>
            {parse(contentString)}
            </ImageContainer>
          </NewsContent>
          <a href="/info"><ReadMoreButton>返回相關資訊</ReadMoreButton></a>
        </NewsContainer>

        

        <Footer /> 

    </NewsTitleAndDateContainer>

  );
}

export default NewsTitleAndDate;